/**
 * Shared singleton worker instances.
 * Import from here instead of calling `new Worker(...)` in multiple places.
 * This guarantees exactly one instance of each worker process.
 */

/**
 * Unified query worker — handles both legacy commands (getcache, getuseracldata,
 * calendarbookings, etc.) and typed commands (dashboard_query, calendar_cache, …).
 * Previously split across query.worker.js (legacy) and query.worker.ts (typed).
 * Spawned eagerly — always needed on startup.
 */
export const databaseWorker = new Worker(
    new URL('./query.worker.ts', import.meta.url),
    { type: 'module' }
)

/**
 * Server/socket worker — shared between tables.ts and WorkerService.ts
 * Spawned eagerly — always needed on startup.
 */
export const serverWorker = new Worker(
    new URL('./server.worker.ts', import.meta.url),
    { type: 'module' }
)

/**
 * getQueryWorker() now returns the same databaseWorker instance.
 * Kept for backward-compat with WorkerService callers.
 */
export function getQueryWorker(): Worker {
    return databaseWorker
}
